<section id="impressum">
  <h2>Impressum</h2>

  <h3>Angaben gemäß § 5 TMG</h3>
  <address>
    <strong>Docuty GmbH</strong><br>
    Regensburger Straße 90<br>
    92318 Neumarkt i.d.OPf.<br>
    Deutschland
  </address>
  <br>
  <p><strong>Vertreten durch:</strong><br>
    Geschäftsführer: Stefan Körner</p>

  <h3>Kontakt</h3>
  <p>Telefon: <a href="tel:+4991812702200">+49 9181 2702200</a><br>
    E-Mail: <a href="mailto:info@docuty.de">info&#64;docuty.de</a>
  </p>

  <h3>Registereintrag</h3>
  <p>
    Eingetragen im Handelsregister.<br>
    Registergericht: Amtsgericht Nürnberg<br>
    Registernummer: HRB 10000
  </p>

  <p><strong>Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG:</strong><br>
    DE 455454211</p>

  <h3>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h3>
  <address>
    Stefan Körner<br>
    Docuty GmbH<br>
    Regensburger Straße 90<br>
    92318 Neumarkt i.d.OPf.
  </address>
</section>

<hr>

<section id="haftungsausschluss">
  <h2>Haftungsausschluss</h2>

  <h3>Haftung für Inhalte</h3>
  <p>
    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
    Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
    Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen,
    die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
    Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
    Bei Bekanntwerden entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
  </p>

  <h3>Haftung für Links</h3>
  <p>
    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
    Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
    Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
    Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
    Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
    Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
    Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
  </p>

  <h3>Urheberrecht</h3>
  <p>
    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
    Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
    Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
    Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.
    Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis.
    Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
  </p>

  <p><em>Quelle: Eigenes Impressum auf Basis gesetzlicher Vorgaben (TMG, MStV, UStG)</em></p>
</section>
